import {
  Autocomplete,Box,Button,CircularProgress,Dialog,DialogActions,DialogContent,DialogTitle,FormControl,FormControlLabel,InputLabel,MenuItem,Radio,RadioGroup,Select,Stack,Switch,TextField,Typography,
} from "@mui/material";

export default function ModalGroupPermissions({
  open,
  form,
  setForm,
  groups,
  accessPoints,
  schedules,
  members,
  selectedExcludedMembers,
  membersLoading,
  saving,
  onClose,
  onSave,
  onGroupChange,
  visitorPermissionOptions,
  visitorPermissions,
  visitorPermissionsLoading,
  onVisitorPermissionChange,
}){
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{form.id?"Editar permiso por rol":"Nuevo permiso por rol"}</DialogTitle>

      <DialogContent>
        <Stack spacing={2.5} sx={{paddingTop:1}}>
          <FormControl fullWidth>
            <InputLabel>Rol</InputLabel>
            <Select value={form.group} label="Rol" onChange={onGroupChange}>
              {groups.filter(group=>group.is_active||group.id===Number(form.group)).map(group=>(
                <MenuItem key={group.id} value={group.id}>{group.name}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel>Acceso</InputLabel>
            <Select value={form.access_point} label="Acceso" onChange={event=>setForm(previous=>({...previous,access_point:event.target.value}))}>
              {accessPoints.filter(accessPoint=>accessPoint.is_active||accessPoint.id===Number(form.access_point)).map(accessPoint=>(
                <MenuItem key={accessPoint.id} value={accessPoint.id}>{accessPoint.name}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel>Horario</InputLabel>
            <Select value={form.schedule} label="Horario" onChange={event=>setForm(previous=>({...previous,schedule:event.target.value}))}>
              <MenuItem value="">Sin horario</MenuItem>
              {schedules.filter(schedule=>schedule.is_active||schedule.id===Number(form.schedule)).map(schedule=>(
                <MenuItem key={schedule.id} value={schedule.id}>{schedule.name}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <Box sx={{border:"1px solid #e5e7eb",borderRadius:2,paddingX:2,paddingY:1}}>
            <Typography sx={{fontSize:13,fontWeight:800,marginBottom:0.5}}>Tipo de regla</Typography>

            <RadioGroup row value={form.is_allowed?"allow":"deny"} onChange={event=>setForm(previous=>({...previous,is_allowed:event.target.value==="allow"}))}>
              <FormControlLabel value="allow" control={<Radio/>} label="Permitir acceso"/>
              <FormControlLabel value="deny" control={<Radio/>} label="Denegar acceso"/>
            </RadioGroup>
          </Box>

          <Box sx={{border:"1px solid #e5e7eb",borderRadius:2,padding:2}}>
            <FormControlLabel
              control={
                <Switch
                  checked={form.limit_dates===true}
                  onChange={event=>{
                    const checked=event.target.checked;

                    setForm(previous=>({
                      ...previous,
                      limit_dates:checked,
                      valid_from:checked?previous.valid_from:"",
                      valid_until:checked?previous.valid_until:"",
                    }));
                  }}
                />
              }
              label="Limitar por fechas"
            />

            <Typography sx={{color:"#6b7280",fontSize:12,marginTop:0.3}}>
              Si está desactivado, el permiso no tendrá límite de fechas y seguirá respetando el horario semanal configurado.
            </Typography>

            {form.limit_dates&&(
              <Box sx={{display:"grid",gridTemplateColumns:{xs:"1fr",sm:"1fr 1fr"},gap:2,marginTop:2}}>
                <TextField fullWidth required type="date" label="Válido desde" value={form.valid_from} onChange={event=>setForm(previous=>({...previous,valid_from:event.target.value}))} InputLabelProps={{shrink:true}}/>
                <TextField fullWidth required type="date" label="Válido hasta" value={form.valid_until} onChange={event=>setForm(previous=>({...previous,valid_until:event.target.value}))} InputLabelProps={{shrink:true}}/>
              </Box>
            )}
          </Box>

          <Box sx={{border:"1px solid #e5e7eb",borderRadius:2,overflow:"hidden"}}>
            <Box sx={{padding:2,borderBottom:"1px solid #e5e7eb",backgroundColor:"#fafafa"}}>
              <Typography sx={{fontSize:14,fontWeight:800}}>Permisos de visitantes</Typography>
              <Typography sx={{color:"#6b7280",fontSize:12,marginTop:0.4}}>
                Estos permisos controlan qué puede hacer este rol con las invitaciones de visitantes desde la aplicación móvil.
              </Typography>
            </Box>

            {!form.group?(
              <Box sx={{padding:2}}>
                <Typography sx={{color:"#6b7280",fontSize:13}}>
                  Selecciona primero un rol para configurar sus permisos de visitantes.
                </Typography>
              </Box>
            ):visitorPermissionsLoading?(
              <Box sx={{minHeight:120,display:"flex",alignItems:"center",justifyContent:"center"}}>
                <CircularProgress size={24}/>
              </Box>
            ):(
              <Stack>
                {visitorPermissionOptions.map((permission,index)=>(
                  <Box key={permission.value} sx={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:2,paddingX:2,paddingY:1.4,borderBottom:index<visitorPermissionOptions.length-1?"1px solid #e5e7eb":"none"}}>
                    <Box sx={{minWidth:0}}>
                      <Typography sx={{fontSize:14,fontWeight:700}}>
                        {permission.label}
                      </Typography>

                      {permission.value==="VISITORS_VIEW_OWN"&&(
                        <Typography sx={{color:"#6b7280",fontSize:12,marginTop:0.2}}>
                          Solo podrá consultar las invitaciones creadas por ese mismo usuario.
                        </Typography>
                      )}

                      {permission.value==="VISITORS_VIEW_ALL"&&(
                        <Typography sx={{color:"#6b7280",fontSize:12,marginTop:0.2}}>
                          Podrá consultar todas las invitaciones creadas dentro del tenant.
                        </Typography>
                      )}

                      {permission.value==="VISITORS_CREATE"&&(
                        <Typography sx={{color:"#6b7280",fontSize:12,marginTop:0.2}}>
                          Permite generar nuevas invitaciones y códigos de acceso para visitantes.
                        </Typography>
                      )}

                      {permission.value==="VISITORS_EDIT"&&(
                        <Typography sx={{color:"#6b7280",fontSize:12,marginTop:0.2}}>
                          Permite modificar invitaciones existentes dentro de su alcance.
                        </Typography>
                      )}

                      {permission.value==="VISITORS_CANCEL"&&(
                        <Typography sx={{color:"#6b7280",fontSize:12,marginTop:0.2}}>
                          Permite cancelar invitaciones dentro de su alcance.
                        </Typography>
                      )}

                      {permission.value==="VISITORS_MANAGE"&&(
                        <Typography sx={{color:"#6b7280",fontSize:12,marginTop:0.2}}>
                          Otorga control completo sobre el módulo de visitantes.
                        </Typography>
                      )}
                    </Box>

                    <Switch
                      checked={visitorPermissions[permission.value]===true}
                      onChange={event=>onVisitorPermissionChange(permission.value,event.target.checked)}
                    />
                  </Box>
                ))}
              </Stack>
            )}
          </Box>

          <Box>
            <Typography sx={{fontSize:14,fontWeight:800,marginBottom:1}}>
              Usuarios excluidos de esta regla
            </Typography>

            {membersLoading?(
              <Box sx={{minHeight:90,display:"flex",alignItems:"center",justifyContent:"center"}}>
                <CircularProgress size={24}/>
              </Box>
            ):(
              <Autocomplete
                multiple
                options={members}
                value={selectedExcludedMembers}
                getOptionLabel={option=>`${option.name} - ${option.identification}`}
                isOptionEqualToValue={(option,value)=>option.id===value.id}
                disabled={!form.group}
                onChange={(_,selectedMembers)=>{
                  setForm(previous=>({
                    ...previous,
                    excluded_person_ids:selectedMembers.map(member=>member.id),
                  }));
                }}
                renderInput={params=>(
                  <TextField {...params} label="Excluir usuarios" placeholder={form.group?"Seleccionar usuarios":"Primero selecciona un rol"}/>
                )}
              />
            )}

            <Typography sx={{color:"#6b7280",fontSize:12,marginTop:0.8}}>
              Los usuarios seleccionados no heredarán esta regla de acceso del rol.
            </Typography>
          </Box>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancelar</Button>

        <Button variant="contained" onClick={onSave} disabled={saving||visitorPermissionsLoading}>
          {saving?<CircularProgress size={20} sx={{color:"#ffffff"}}/>:form.id?"Guardar cambios":"Crear permiso"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}